// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyCCGj2yUFjmAFad6oT-R5W_DNHPDl1JOx4",
    authDomain: "villa-purificacion-74a9b.firebaseapp.com",
    projectId: "villa-purificacion-74a9b",
    storageBucket: "villa-purificacion-74a9b.firebasestorage.app",
    messagingSenderId: "843038150751",
    appId: "1:843038150751:web:8675a0af792b97af6ccbea"
  },
  production: false,
  apiUrl: 'https://admin.api.municipios.saion.mx/',

};
